import styled, { css } from 'styled-components';
import { theme } from '../../theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const { colors } = theme;

export const DivSection = styled.div`
  margin-bottom: 5rem;
`;

export const DivTitleWrapper = styled.div`
  margin-bottom: 1.7rem;
  padding-bottom: 1.5rem;
  font-size: 1.385rem;
  font-weight: 600;
  color: ${colors.textPrimary};
  border-bottom: 1px solid ${colors.secondary};
`;

export const DivTitle = styled.div`
  padding-right: 5rem;
`;

export const FontAwesomeIconStyled = styled(FontAwesomeIcon)`
  margin-right: 1rem;
  color: ${colors.error};
`;

export const DivDescription = styled.div`
  margin-bottom: 1.7rem;
  font-size: 1.078rem;
  font-weight: 500;
  color: ${colors.textDeaccent};
`;

export const DivContent = styled.div`
  padding-right: 3.462rem;
`;

export const DivImageBlock = styled.div`
  margin-bottom: 1.3rem;
  display: flex;
  align-items: center;

  & > div.mockup-thumbnail {
    margin-right: 1rem;
    width: 3.846rem;
    min-width: 3.846rem;
    height: 3.846rem;
    min-height: 3.846rem;
  }
`;

export const DivImageDescription = styled.div`
  min-height: 3.846rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const DivExtendedName = styled.div<{ checkboxBlock?: boolean }>`
  font-size: 1.231rem;
  font-weight: 600;
  color: ${colors.textPrimary};

  ${(props) =>
    props.checkboxBlock &&
    css`
      font-size: 1.078rem;
      font-weight: 500;
    `}
`;

export const DivInfo = styled.div`
  font-size: 1.078rem;
  font-weight: 500;
  color: ${colors.textDeaccent};
`;

export const SpanCreated = styled.span`
  font-weight: 600;
`;

export const DivFooter = styled.div`
  display: flex;

  & > button:first-of-type {
    margin-right: 1rem;
  }
`;
